import { Show, UserButton } from '@clerk/react';
import Box from '@mui/material/Box';

export function UserButtonWrapper() {
  return (
    <Show when="signed-in">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <UserButton
          appearance={{
            variables: { colorPrimary: '#6B46C1' },
          }}
        />
      </Box>
    </Show>
  );
}
